import { createSlice } from "@reduxjs/toolkit";

const biometricInitState = {
  isLoading: false,
  biometrics: [],
  biometric: {},
};

const biometricsReducerSlice = createSlice({
  name: "biometrics",
  initialState: biometricInitState,
  reducers: {
    changeBiometricLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },

    setBiometricState: (state, action) => {
      if (state.biometrics.length <= 0 || action.payload.refresh) {
        state.biometrics = action.payload.biometrics || state.biometrics;
      }
      state.isLoading = false;
    },
    addBiometricState: (state, action) => {
      state.biometrics.unshift(action.payload);
      state.isLoading = false;
    },
    updateBiometricState: (state, action) => {
      state.biometrics.unshift(action.payload);
      state.isLoading = false;
    },
  },
});

export const {
  changeBiometricLoading,
  setBiometricState,
  addBiometricState,
  updateBiometricState,
} = biometricsReducerSlice.actions;

export default biometricsReducerSlice.reducer;
